(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vp-patches-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('patches-product')) {
    customElements.define('patches-product', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.form = this.querySelector('form');
        this.addEventListener('change', (event) => { if (event.target.matches('[data-vp-pack]')) this.sync(); }, { signal });
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-vp-thumb]');
          if (thumb) this.selectImage(thumb.dataset.vpThumb);
        }, { signal });
        this.addEventListener('vertaline:form:ready', () => this.sync(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const slide = event.target.closest('[data-vp-slide]');
          if (slide) this.selectImage(slide.dataset.vpSlide);
          const radio = event.target.querySelector('[data-vp-pack]');
          if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        }, { signal });
        this.sync();
        const sticky = this.querySelector('[data-vp-sticky]');
        const buy = this.querySelector('[data-vp-buy]');
        if (sticky && buy && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          }, { threshold: 0 });
          this.observer.observe(buy);
          this.busyObserver = new MutationObserver(() => this.sync());
          this.busyObserver.observe(this.form, { attributes: true, attributeFilter: ['aria-busy'] });
        }
      }
      selectImage(id) {
        this.querySelectorAll('[data-vp-slide]').forEach((slide) => { slide.hidden = slide.dataset.vpSlide !== id; });
        this.querySelectorAll('[data-vp-thumb]').forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.dataset.vpThumb === id)));
      }
      sync() {
        const selected = Array.from(this.querySelectorAll('[data-vp-pack]')).find((input) => input.checked);
        const busy = this.form?.getAttribute('aria-busy') === 'true';
        const available = selected && !selected.disabled;
        this.querySelectorAll('[data-vp-price]').forEach((node) => { node.textContent = available ? ' · ' + selected.dataset.price : ''; });
        this.querySelectorAll('[data-vp-buy], [data-vp-sticky-buy]').forEach((button) => { button.disabled = !available || busy; });
        const label = this.querySelector('[data-vp-buy] > span');
        if (label) label.textContent = available ? this.dataset.buy : this.dataset.unavailable;
        const title = this.querySelector('[data-vp-sticky-title]');
        if (title) title.textContent = selected?.dataset.title || '';
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.busyObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
